import moment from 'moment'
import { Utils } from '@/utils/utils'
import session from '@/utils/session'; // 获取本地存储
import { Message } from 'element-ui';
import { getSystemTime } from '@/api/common';


const thresholdValue = 5 * 60 * 1000 // 阈值
/**
 * 系统时间
 */
class SystemTime {

    /**
     * 获取服务器时间 时间戳格式
     */
    static getSystemTime() {
        return new Promise((resolve, reject) => {
            getSystemTime().then(res => {
                if (res.code == 200) {
                    resolve(res.data.date_local)
                } else {
                    resolve(moment().valueOf())
                }
            })
        })
    }

    /**
     * 获取本地时间
     */
    static getLocalTime() {
        return moment().valueOf()
    }

    /**
     * 判断电脑是否更改了时间，并矫正差值
     * sysTime 服务器时间
     * 判断服务器时间和本地的差值是否大于一个阈值 大于则用户修改了时间
     */
    static correctDiffValue(sysTime) {
        let localTime = this.getLocalTime()
        let diffValue = localTime - sysTime
        if (Utils.gt(Math.abs(diffValue), thresholdValue)) {
            Message.closeAll()
            Message.error('检测到电脑时间与当前时间不符，请先设置正确时间')
        }
        session.set('diffValue', diffValue)
    }

    /**
     * 获取矫正后的时间
     */
    static getCorrect() {
        let diffValue = session.get('diffValue')
        let localTime = moment().valueOf()
        return localTime - diffValue 
    }
}

export { SystemTime, thresholdValue }